/**
 * Rotas em que o chat não aparece: dispositivo compartilhado (totem), captura
 * de câmera e fluxos de link direto que não devem ter nada por cima.
 */
export const WEBCHAT_BLOCKED_ROUTES = [
  '/sorteiototem',
  '/checkout/reconhecimento-facial/:id',
  '/cliente/reconhecimento-facial/:hash',
  '/consentimento/:encodeClientId',
  '/pendencias/pix/:hash',
];
